export default "__VITE_ASSET__959e82cd__"